export const getTelephonyEndpointsUrl = () => 'business/telephony_endpoints';
export const getTelephonyEndpointUrl = (id: number | string) => `business/telephony_endpoints/${id}`;
export const getTelephonyEndpointAvailableNumbersUrl = () => 'business/telephony_endpoints/available_numbers';
export const getTelephonyEndpointPurchaseUrl = () => 'business/telephony_endpoints/purchase';
export const getTelephonyEndpointAssignmentsUrl = (id: number | string) =>
  `business/telephony_endpoints/${id}/assignments`;
export const getTelephonyEndpointGatewayStateUrl = (id: number | string) =>
  `business/telephony_endpoints/${id}/gateway_state`;
